import { confirmable, ContextAwareConfirmation } from 'react-confirm';
import { ConfirmModal } from 'src/projects/components/ConfirmModal.tsx';

export const confirm = ContextAwareConfirmation.createConfirmation(confirmable(ConfirmModal));
